<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login" autocomplete="off">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>

                  <fg-input v-model="forms.user" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Email"></fg-input>

                  <fg-input v-model="forms.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password"
                            type="password"></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="info" round block class="mb-3">Login</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/bg-bwp.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from 'src/components/UIComponents';
import AppNavbar from './Layout/AppNavbar';
import AppFooter from './Layout/AppFooter';

// Import Firebase authentication methods
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },
  data() {
    return {
      forms: {
        user: '', // Changed to 'email' for Firebase compatibility
        password: '',
      },
    };
  },
  methods: {
    async login() {
      const auth = getAuth(); // Initialize Firebase Auth
      const { user, password } = this.forms;

      try {
        // Attempt to log in the user
        const userCredential = await signInWithEmailAndPassword(auth, user, password);

        // Successfully logged in
        console.log('User logged in:', userCredential.user);

        // Redirect or show a success message
        this.$router.push('/lobbyfood/list'); // Example: Redirect to dashboard
      } catch (error) {
        // Handle login errors
        console.error('Login error:', error.message);
        alert('Login failed: ' + error.message);
      }
    },
  },
};
</script>

<style>
</style>
